export const SUPPLIER_GROUP_DOCUMENT_DROP_DOWN_ITEMS = []